import { render, staticRenderFns } from "./cookies-information.vue?vue&type=template&id=c491bc66"
import script from "./cookies-information.vue?vue&type=script&lang=js"
export * from "./cookies-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports